import { Box, theme } from '@arpeggi/ui'
import { FC } from 'react'
import { Discussion } from '../../../features/discussions'
import { ConditionalWrapper } from '../../../__legacy__/components/core/ConditionalWrapper'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import { Discussions, Section, TokenGatedEmptyState } from '../primitives'
import { SectionEmptyState } from './SectionEmptyState'

interface Props {
  discussionId: number
  isBlocked?: boolean
  emptyStateOnClick: () => void
}

export const DiscussionTabContent: FC<Props> = ({ discussionId, isBlocked, emptyStateOnClick }) => {
  const color = theme.colors.blackA100.value

  return (
    <Box>
      <Tabs.Content value="#discussion">
        <Section.Root>
          <Section.Flare1 css={{ color }} />
          <Section.Flare2 css={{ color }} />
          <Section.Content>
            <ConditionalWrapper
              condition={isBlocked}
              wrapper={(children) => (
                <TokenGatedEmptyState.OpacityGradientContainer>
                  <Box width="full">{children}</Box>
                </TokenGatedEmptyState.OpacityGradientContainer>
              )}
            >
              <Discussions.Root>
                <Discussion
                  discussionId={discussionId}
                  perPage={isBlocked ? 2 : 25}
                  disableInfintieScroll={isBlocked}
                  commentLineClamp={isBlocked ? 2 : undefined}
                />
              </Discussions.Root>
            </ConditionalWrapper>
            {isBlocked && (
              <SectionEmptyState
                onClick={emptyStateOnClick}
                artistName="test"
                title="Discussions are token gated. Collect a token to join the discussion."
              />
            )}
          </Section.Content>
        </Section.Root>
      </Tabs.Content>
    </Box>
  )
}
